<template>
    <div>
        <h2><strong>Contratos Renovación </strong></h2>
        <a @click="$router.go(-1)">regresar</a>
        <br><br>
        <input type='text' placeholder='BUSCAR' v-model='abuscar'  >
        <br>
        <br>

        <table  class="table is-striped"  id='contratos-lista' v-if="contratosTodos !=null">
            <thead>
                <tr>
                    <th>Propiedad</th>
                    <th>Inquilino</th>
                    <th>Nombre/Giro</th>
                    <th>Familia</th>
                    <th>Renta</th>
                    <th>Inicio/Termino</th>
                    <th>Status</th>
                    <th>Avisar</th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="contrat in buscando" v-if="contrat.status != 'PROFORMA' && contrat.status == 'RENTADO'" >   
                    <td>{{contrat.propiedad}}</td>
                    <td>{{contrat.inquilino}}</td>
                    <td><strong>{{contrat.nombreComercial}}/{{contrat.giro}}</strong></td>
                    <td>{{contrat.familia}}/{{contrat.subfamilia}}</td>                   
                    <td><b> ${{formateaNumero(contrat.importeMes)}}
                        <br>{{contrat.area}}M2</b>
                        <br>${{formateaNumeroSimple(contrat.importeMes/contrat.area)}}/m2
                    </td>
                    <td>{{formateaFecha(contrat.fechaInicio)}}<strong> / </strong>{{formateaFecha(contrat.fechaTerminacion)}}</td>
                    <td><font color="red">
                        {{contrat.vencidoEsta = vencido(contrat.fechaTerminacion, contrat.status)}}</font></td>
                    <td>
                        <div v-if="contrat.vencidoEsta !='' ">
                            <span >Nueva renta sugerida </span><span v-if="contrat.rentaSugerida"><b>(${{formateaNumero(contrat.rentaSugerida/contrat.area) }}/m2)</b></span><span><input class="input" type="number" name="cuanto" number v-model="contrat.rentaSugerida"></span>
                            <br><br>
                            <textarea id="mensaje" disabled cols='40' rows="10" 
                                v-if="Number(contrat.rentaSugerida) >= Number(contrat.importeMes) && contrat.emailInquilino " 
                                v-model= "contrat.mensaje='Apreciable ' + contrat.inquilino +' es necesario firmar su nuevo contrato en caso de que desee seguir rentando el inmueble ' + contrat.propiedad + '. Por lo que le informamos que su nueva renta será de $ ' + formateaNumero(contrat.rentaSugerida) + ' Por favor verifique sus datos en esta liga: ' + datosActuales + contrat.id " >                    
                            </textarea>

                            <br>
                            <strong>
                                <div v-if="contrat.fechaAvisoRenovar" style="color:hsl(0,100%,50%);">
                                    <div class="notification is-primary">
                                        <p>
                                            Ya avisado por mail el {{formateaFecha(contrat.fechaAvisoRenovar)}} a ${{formateaNumeroSimple(contrat.avisoNuevaRenta)}}
                                        </p>
                                    </div>
                                </div>
                            </strong>
                            <button 
                                v-if="Number(contrat.rentaSugerida) > Number(contrat.importeMes) && contrat.emailInquilino " 
                                class="button is-primary" 
                                v-on:click="enviaMail(contrat.emailInquilino, contrat.rentaSugerida, contrat.mensaje, contrat.id)" >Enviar al mail {{contrat.emailInquilino}}
                            </button>&nbsp&nbsp&nbsp

                            <div v-if="contrat.celularInquilino && Number(contrat.rentaSugerida) >= Number(contrat.importeMes)">
                                <a  v-bind:href="'https://wa.me/521' + contrat.celularInquilino + '?text=Apreciable%20' + contrat.inquilino +'%20es%20necesario%20firmar%20su%20nuevo%20contrato%20en%20caso%20de%20que%20desee%20seguir%20rentando%20el%20inmueble%20' + contrat.propiedad + '.%20Por%20lo%20que%20le%20informamos%20que%20su%20nueva%20renta%20será%20de%20$%20' + formateaNumero(contrat.rentaSugerida) + '%20Por%20favor%20verifique%20sus%20datos%20en%20esta%20liga:%20' + datosActuales + contrat.id "  target = "_blank" >

                                    <i class="fab fa-whatsapp fa-2x"></i>
                                </a>   
                            </div>
                        </div>
                    </td>                        
                </tr>
            </tbody>
        </table>
        <div v-else><button class="button is-primary is-loading"></button></div>
    </div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Contratos-renovacion',
  mounted(){
    this.getContratos();
  },
  props: ['vector'],  
  data () {
    return {
      contratosTodos: null,
      abuscar:'',
      total:'',
      mailRentus: 'rentusqro@gmail.com',
      datosActuales: 'https://www.directodo.com/Rentus/renovacion.php?w=4423382549&cont78357=' 
    }
  },
  methods:{
    getContratos(){
                // checa si tiene autorizacion
        if(!this.vector.includes('MASTERGGUV')){
            if(!this.vector.includes('Contratos')){
                alert('Seccion no autorizada');
                return;
            }
        }       
        axios.get('https://www.directodo.com/Rentus/accesosdb/leeContratos.php')
             .then((respuesta) => {
                this.contratosTodos = respuesta.data;
                // agregamos dos columnas vacias para usarlas despues
                this.contratosTodos.newCol("rentaSugerida");
                this.contratosTodos.newCol("rentaNueva");
                this.contratosTodos.newCol("vencidoEsta");
                this.contratosTodos.newCol("mensaje");
             });
    },

    vencido: function(fecha, status){

        var fecha1 = new Date(fecha); 
        fecha1.setHours(0); 

        var hoy = new Date(); 
        hoy.setHours(0);

        var fechams = fecha1.getTime(); // en milisegundos              
        var hoyms = hoy.getTime(); // en milisegundos

        var unMes = 30 * 24 * 60 * 60 * 1000;// en milisegundos

        if(fechams < (hoyms + unMes + unMes)){// checa si se vencera en los proximos 2 meses
            var diferencia = hoyms - fechams;

            if(fechams < hoyms){
                return "Contrato VENCIDO el " + this.formateaFecha(fecha) + " \nHACE " + (diferencia/unMes).toFixed(0) +" MESES \nFavor de RENOVARLO"; 
            }else{
                return "POR VENCER el " + this.formateaFecha(fecha)  + " \nEN " + (-diferencia/unMes).toFixed(0) +" MESES ; "
            }
            
        } else {
            return "";
        }

    },

    formateaFecha: function (fecha) {
        var d = new Date(fecha); 
        if (Date.parse(d)){
            // pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
            d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
            d.setHours(0);
            var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
            d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
            return d} 
        else{return "sin fecha";}
    },
    
    formateaNumero(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
    },

    formateaNumeroSimple(valor1) {
        return (Number(valor1)).toLocaleString('en-US', {maximumFractionDigits: 0});
    },
    fechaActual(){      
        var currentDate = new Date() //hoy
        var day = currentDate.getDate();
        var month = currentDate.getMonth() + 1;
        var year = currentDate.getFullYear();
        var my_date = year+"-"+month+"-"+day;
        return my_date;  
    },
    enviaMail(mail, rentaNueva, elMensaje, contrato){
        // envia mail y agerga bandera de ya enviado al tal mail
        axios.get('https://www.directodo.com/Rentus/accesosdb/enviaMailInquilino.php?mai11='+ mail + "&ren11=" + rentaNueva + "&men11=" + elMensaje + "&con11=" + contrato )
             .then((respuesta) => {
                alert("\n\n\nMail enviado a " + mail);
             });        
    }

  },
  computed:{
    buscando: function (){
        return this.contratosTodos.filter((item) =>  
               item.propiedad.toUpperCase().includes(this.abuscar.toUpperCase()) 
            || item.inquilino.toUpperCase().includes(this.abuscar.toUpperCase()) 
            || item.familia.toUpperCase().includes(this.abuscar.toUpperCase()) 
            || item.giro.toUpperCase().includes(this.abuscar.toUpperCase()) 
            || item.id.toUpperCase().includes(this.abuscar.toUpperCase()) 
            || item.nombreComercial.toUpperCase().includes(this.abuscar.toUpperCase()) 
        );
    }
  }
}
</script>

<style >

</style>


// WEBPACK FOOTER //
// src/Contratos-renovacion.vue